import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import Classes from '../../../../common/Classes';
import ProductImage from '../../../../common/exhibitingOrganisation/ProductImage';
import DocumentImage from '../../../../common/exhibitingOrganisation/DocumentImage';
import {DataDtmActions, Devices, ScreenSizes} from '../../../../common/Constants';
import bundledAssets from '../../../../../images/assets.json';
import {ItemType} from '../../../../common/Constants';
import PremiumExhibitorCarouselClip from '../../../../common/exhibitingOrganisation/PremiumExhibitorCarouselClip';
import Utils from '../../../../common/Utils';

const ThumbnailWrapper = ({ product, src, alt, imageSize, translations, imageDataDtm, imageOnClick, imageIndex, type, clipText, innovativeProductClipText, mixpanelProps, isVideoAvailable}) => {
    const productImageProps = {
        src: Utils.getProductVideoOrImageUrl(product),
        imageSize: imageSize,
        alt: alt,
        translations: translations,
        fallbackImage: bundledAssets.defaultProductImageUrl,
        onClick: imageOnClick,
        imageIndex: imageIndex,
        clipText: clipText,
        innovativeProductClipText: innovativeProductClipText,
        isVideoAvailable: isVideoAvailable,
        product
    };

    return (
        <div className={Classes.imgContainer}
            data-dtm={imageDataDtm?.tag}
            data-dtm-actions={imageDataDtm ? DataDtmActions.click : null}
            data-dtm-attributes={imageDataDtm?.attributes}
            data-testid={`${type}-image-container`}
        >
            <div
                className={Classes.imageInDirectoryContainer}
                data-dtm={imageDataDtm?.tag}
                data-dtm-actions={imageDataDtm ? DataDtmActions.view : null}
                data-dtm-attributes={imageDataDtm ? imageDataDtm.attributes : null}
                data-testid={`${type}-image-in-directory`}
            >
                <>
                { type === ItemType.Product ?
                    <>
                        <MediaQuery minWidth={1199}>
                            <ProductImage {...productImageProps } deviceType={`${Devices.desktop}-${ScreenSizes.small}`} mixpanelProps={mixpanelProps} />
                        </MediaQuery>
                        <MediaQuery minWidth={992} maxWidth={1198}>
                            <ProductImage {...productImageProps } deviceType={`${Devices.desktop}-${ScreenSizes.large}`} mixpanelProps={mixpanelProps}/>
                        </MediaQuery>
                        <MediaQuery minWidth={768} maxWidth={991}>
                            <ProductImage {...productImageProps } deviceType={`${Devices.desktop}-${ScreenSizes.small}`} mixpanelProps={mixpanelProps}/>
                        </MediaQuery>
                        <MediaQuery maxWidth={767}>
                            <ProductImage {...productImageProps } deviceType={`${Devices.mobile}-${ScreenSizes.small}`} mixpanelProps={mixpanelProps}/>
                        </MediaQuery>
                    </>
                    : <DocumentImage src={src} alt={alt} onClick={imageOnClick} imageIndex={imageIndex} mixpanelProps={mixpanelProps}/>
                }
                </>
            </div>
            { clipText && <PremiumExhibitorCarouselClip text= {clipText} /> }
            { innovativeProductClipText && <PremiumExhibitorCarouselClip text= {innovativeProductClipText} isInnovative={true} /> }
        </div>
    )
};


ThumbnailWrapper.propTypes = {
    src: PropTypes.string.isRequired,
    imageSize: PropTypes.string,
    alt: PropTypes.string,
    imageDataDtm: PropTypes.object,
    imageOnClick: PropTypes.func,
    imageIndex: PropTypes.number,
    type: PropTypes.string,
    clipText: PropTypes.string,
    innovativeProductClipText: PropTypes.string,
    mixpanelProps: PropTypes.object,
    isVideoAvailable: PropTypes.bool
};

export default ThumbnailWrapper;
